import { css } from 'emotion';

export const driverName = css`
  white-space: initial;
`;
